import { defineStore } from "pinia";
export const useSettingsStore = defineStore("settings", {
    state: () => ({
        termsOfPaidAdvertising: null,
        advertisements: null,
        multimediaType: null,
        announcements: null,
        appointments: null,
        settingsState: null,
        general: null,
    }),
    actions: {
        async getApi() {
            return axios
                .get("settings")
                .then(({ data }) => {
                    this.termsOfPaidAdvertising = data.terms_of_paid_advertising;
                    this.advertisements = data.advertisements;
                    this.announcements = data.announcements;
                    this.appointments = data.appointments;
                    this.multimediaType = data.multimedia_type;
                    this.general = data.general;
                    this.settingsState = data.settings_state;
                    return data;
                })
                .catch((error) => {
                    throw error;
                });
        },
    },
    getters: {
        getTermsOfPaidAdvertising: (state) => state.termsOfPaidAdvertising,
        getAds: (state) => state.ads,
        getMultimediaType: (state) => state.multimediaType,
        getGeneral: (state) => state.general,
        getSettingsState: (state) => state.general,
    },
});
